import { BenefitCard } from './benefits.model'

export const benefitCards: BenefitCard[] = [
  {
    image: 'tecnologia-favor.png',
    alt: 'Duas mulheres acessando crédito pelo computador'
  },
  {
    image: 'condicoes-flexiveis.png',
    alt: 'Mulher sorrindo enquanto utiliza o smartphone'
  },
  {
    image: 'processo-descomplicado.png',
    alt: 'Mulher sorrindo durante atendimento por telefone'
  },
  {
    image: 'esperiencia-humanizada.png',
    alt: 'Cliente e especialista sorrindo durante atendimento'
  }
]
